import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { filter, first, map, tap } from 'rxjs/operators';

import { Store } from '@ngrx/store';

import {
  LocationAllowedOsUpdateStoreActions,
  LocationAllowedOsUpdateStoreStates,
} from '../location-allowed-os-updates/index';

import { LocationsRouterStoreSelectors, RouterStoreStates } from '../router/index';

@Injectable()
export class LocationAllowedOsUpdateResolver {
  constructor(
    private readonly routerStore: Store<RouterStoreStates.RouterState>,
    private readonly locationAllowedUpdateStore: Store<LocationAllowedOsUpdateStoreStates.LocationAllowedOsUpdate>
  ) {}

  resolve(): Observable<boolean> {
    return this.routerStore.select(LocationsRouterStoreSelectors.selectLocationId).pipe(
      filter((x) => !!x),
      tap((locationId) => {
        this.locationAllowedUpdateStore.dispatch(
          LocationAllowedOsUpdateStoreActions.LocationAllowedOsUpdatesResolverActions.requested({
            locationId,
          })
        );
      }),
      map(() => true),
      first()
    );
  }
}
